import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Stack,
  FormControl,
  FormLabel,
  Input,
  Icon,
  RadioGroup,
  Radio,
  Box,
  IconButton,
} from "@chakra-ui/react";
import {
  FaEdit,
  FaPlus,
  FaTrash,
  FaListAlt,
  FaMoneyBillWave,
  FaCalendarAlt,
} from "react-icons/fa";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Edit_Fine = ({ fineId, schoolId, userId, RefreshData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fineType, setFineType] = useState("fixed");
  const [fineAmount, setFineAmount] = useState("");
  const [intervals, setIntervals] = useState([]);
  const [fineStartDate, setFineStartDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");

  // Open Modal and Reset Fields
  const openModal = () => {
    setIsModalOpen(true);
    resetFields();
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setError(null);
    setSuccessMessage("");
  };

  const resetFields = () => {
    setFineType("fixed");
    setFineAmount("");
    setIntervals([]);
    setFineStartDate("");
  };

  // Fetch Fine Details if Editing
  useEffect(() => {
    if (isModalOpen && fineId && schoolId) {
      fetchFineDetails();
    }
  }, [isModalOpen, fineId, schoolId]);

  const fetchFineDetails = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(
        `${BASE_URL}/admin/bus/fee/view_fee_structure.php?fine_id=${fineId}&school_id=${schoolId}`
      );
      const data = await response.json();
      console.log("view", data);

      if (data.success) {
        const fine = data.data;
        setFineType(fine.fine_type || "fixed");
        setFineAmount(fine.fixed_fine_amount || "");
        setFineStartDate(fine.fine_start_date || "");
        setIntervals(fine.fine_intervals || []);
      } else {
        setError(data.message || "Failed to fetch fine details.");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Handle Input Changes
  const handleFineAmountChange = (e) => setFineAmount(e.target.value);

  const handleIntervalChange = (index, field, value) => {
    const updatedIntervals = [...intervals];
    updatedIntervals[index][field] = value;
    setIntervals(updatedIntervals);
  };

  const addNewInterval = () =>
    setIntervals([...intervals, { days: "", fine_amount: "" }]);

  const deleteInterval = (index) => {
    const updatedIntervals = intervals.filter((_, i) => i !== index);
    setIntervals(updatedIntervals);
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);
    setSuccessMessage("");

    const updatedFine = {
      id: fineId,
      school_id: schoolId,
      user_id: userId,
      fine_type: fineType,
      // fine_start_date: fineStartDate,
      fixed_fine_amount: fineType === "fixed" ? fineAmount : 0,
      fine_interval: fineType === "interval" ? intervals : [],
    };
    console.log("updated_fineeee", updatedFine);

    try {
      const response = await fetch(
        `${BASE_URL}/admin/bus/fee/edit_fee_structure.php`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedFine),
        }
      );

      const data = await response.json();
      console.log("edit_data", data);

      if (data.success) {
        setSuccessMessage(data.message || "Fine updated successfully.");
        closeModal();
        RefreshData();
      } else {
        setError(data.message || "Failed to update fine.");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <IconButton
        icon={<FaEdit />}
        colorScheme="blue"
        size="sm"
        onClick={openModal}
        aria-label="Edit"
      />

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        size="lg"
        motionPreset="slideInBottom"
      >
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          borderRadius="lg"
          boxShadow="xl"
          bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
          color="gray.700"
          p={6}
          maxW="700px"
          maxH="550px"
          overflowY="auto"
        >
          <ModalHeader
            fontSize="xl"
            fontWeight="bold"
            textAlign="center"
            color="teal.600"
          >
            <Icon as={FaEdit} boxSize={5} mr={2} />
            Edit Fine Details
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody
            overflowY="auto"
            px={4}
            css={{
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-track": {
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "rgba(173, 216, 230, 0.6)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "rgba(173, 216, 230, 0.9)",
              },
            }}
          >
            {loading ? (
              <p>Loading...</p>
            ) : error ? (
              <p style={{ color: "red" }}>{error}</p>
            ) : successMessage ? (
              <p style={{ color: "green" }}>{successMessage}</p>
            ) : (
              <Stack spacing={4}>
                <FormControl>
                  <FormLabel>
                    {" "}
                    <Icon as={FaListAlt} mr={1} color="teal.500" />
                    Fine Type
                  </FormLabel>
                  <RadioGroup
                    value={fineType}
                    onChange={(value) => setFineType(value)}
                  >
                    <Stack direction="row">
                      {fineType !== "fixed" && (
                        <Radio value="interval">Interval</Radio>
                      )}
                      {fineType !== "interval" && (
                        <Radio value="fixed">Fixed</Radio>
                      )}
                    </Stack>
                  </RadioGroup>
                </FormControl>

                {fineType === "fixed" && (
                  <FormControl>
                    <FormLabel>
                      {" "}
                      <Icon as={FaMoneyBillWave} mr={1} color="teal.500" />
                      Fine Amount
                    </FormLabel>
                    <Input
                      bg="white"
                      _hover={{ borderColor: "teal.300" }}
                      type="number"
                      value={fineAmount}
                      onChange={handleFineAmountChange}
                      placeholder="Enter fixed fine amount"
                    />
                  </FormControl>
                )}

                {fineType === "interval" && (
                  <Box>
                    {intervals.map((interval, index) => (
                      <Box key={index} mb={4}>
                        <Stack direction="row" spacing={4} align="center">
                          <FormControl>
                            <FormLabel>
                              {" "}
                              <Icon
                                as={FaCalendarAlt}
                                mr={1}
                                color="teal.500"
                              />
                              Days
                            </FormLabel>
                            <Input
                              bg="white"
                              _hover={{ borderColor: "teal.300" }}
                              type="number"
                              value={interval.days}
                              onChange={(e) =>
                                handleIntervalChange(
                                  index,
                                  "days",
                                  e.target.value
                                )
                              }
                            />
                          </FormControl>
                          <FormControl>
                            <FormLabel>
                              {" "}
                              <Icon
                                as={FaMoneyBillWave}
                                mr={1}
                                color="teal.500"
                              />
                              Fine Amount
                            </FormLabel>
                            <Input
                              bg="white"
                              _hover={{ borderColor: "teal.300" }}
                              type="number"
                              value={interval.fine_amount}
                              onChange={(e) =>
                                handleIntervalChange(
                                  index,
                                  "fine_amount",
                                  e.target.value
                                )
                              }
                            />
                          </FormControl>
                          <IconButton
                            aria-label="Delete Interval"
                            icon={<FaTrash />}
                            colorScheme="red"
                            size="sm"
                            onClick={() => deleteInterval(index)}
                          />
                        </Stack>
                      </Box>
                    ))}
                    <Button
                      leftIcon={<FaPlus />}
                      size="sm"
                      colorScheme="green"
                      onClick={addNewInterval}
                    >
                      Add Interval
                    </Button>
                  </Box>
                )}
              </Stack>
            )}
          </ModalBody>
          <ModalFooter>
            {/* <Button variant="ghost" onClick={closeModal}>
              Cancel
            </Button> */}
            <Button
              bgGradient="linear(to-r, teal.400, teal.600)"
              color="white"
              _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
              onClick={handleSubmit}
              isDisabled={loading}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default Edit_Fine;
